import type React from 'react';

import { CheckCircleIcon, CrossCircleIcon } from '@vlabs/icons';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import st from './FaceQualityChecksRow.module.sass';
import { formatValue, formatThreshold } from './formatters';

export interface FaceQualityChecksRowProps {
  name: string;
  object_value: number;
  threshold_value: number | {
    min: number;
    max: number;
  } | {
    min: number;
  } | string[];
  result: number;
}

function FaceQualityChecksRow({
  name,
  object_value,
  threshold_value,
  result,
}: FaceQualityChecksRowProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    <tr className="CheckRow">
      <td>
        <div
          className={classNames(st.CheckName, {
            [st.CheckName_success as string]: result === 1,
            [st.CheckName_fail as string]: result === 0,
          })}
        >
          <div className={st.CheckIcon}>
            {result === 0 && <CrossCircleIcon />}
            {result === 1 && <CheckCircleIcon />}
          </div>
          {t(`checks:checks.${name}`)}
        </div>
      </td>
      <td>
        <div className={st.CheckValue}>
          {formatValue({ name, object_value })}
        </div>
      </td>
      <td>
        <div className={st.CheckThreshold}>
          {formatThreshold({ name, threshold_value })}
        </div>
      </td>
    </tr>
  );
}

export { FaceQualityChecksRow };
